/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Card, CardBody, Col, Container, Button, UncontrolledTooltip } from 'reactstrap'
import { connect } from 'react-redux';
import DataTable from 'react-data-table-component'

import Breadcrumbs from '../CommonElements/Breadcrumbs'

import { getVerifications as getVerificationsAction } from '../ReduxToolkit/Reducers/verifications';
import { useNavigate } from 'react-router-dom';
import { getCamelCaseWord } from '../static/brands_wholesalers_data';

function Verifications({ getVerifications, verifications, totalVerifications, selectedFilters }) {
  const navigate = useNavigate();
  const [page, setPage] = useState(selectedFilters?.page || 1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tableData, setTableData] = useState(verifications[page] || []);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (page) {
      // if (verifications[page] && verifications[page]?.length === itemsPerPage) {
      //   setTableData(verifications[page]);
      //   setIsLoading(false);
      // } else {
      _getTableData();
      // }
    }
  }, [page]);

  useEffect(() => {
    if (verifications[page]) {
      setTableData(verifications[page]);
    }
  }, [verifications]);

  useEffect(() => {
    _getTableData();
  }, [itemsPerPage]);

  useEffect(() => {
    if ((tableData?.length > 0 && tableData?.length !== 10) || itemsPerPage !== 10) {
      _getTableData();
    }
  }, [itemsPerPage]);

  const _getTableData = async (hideLoader = false) => {
    if (!hideLoader) setIsLoading(true);
    await getVerifications(page, itemsPerPage);
    setIsLoading(false);
  };

  const _handleItemPerPageSelect = async (count) => {
    setPage(1);
    setItemsPerPage(count);
  };

  return (
    <div className='page-body'>
      <Breadcrumbs pageTitle='Verifications' parent='Home' title='Verification Table' />
      <Container fluid>
        <Col sm={12}>
          <Card>
            <CardBody>
              {/* <Row className="align-items-center justify-content-between">
                <Col xs="auto" className='d-flex flex-row gap-3 align-items-center'>
                  {selectedRowsData?.selectedCount > 0 && (
                    <>
                      <Input type="select" style={{ width: '150px' }} onChange={handleAssignBrandsToCompany}>
                        <option value={null}>Select</option>
                        {companies?.map((company) => (
                          <option key={company?.id} value={company?.id}>
                            {company?.name}
                          </option>
                        ))}
                      </Input>
                      <Button outline color='primary' onClick={() => setConfirmationModal(true)}><Trash /></Button>
                    </>
                  )}
                  <button style={{ border: 'none', outline: 'none', padding: '10px 15px', borderRadius: '7px' }} onClick={() => navigate(`/import-data/brand`)}>
                    + Import Brand
                  </button>

                  <button onClick={() => setManuallModal(true)} style={{ border: 'none', outline: 'none', padding: '10px 15px', borderRadius: '7px', color: 'white', backgroundColor: 'black' }}>
                    Add Brand Manually
                  </button>
                </Col>
                <Col xs="auto" className='d-flex flex-row gap-3 align-items-center'>
                  <Label className='mb-0'>{'Search'}:</Label>
                  <Input type="text" placeholder='Search name or domain...' value={searchTerm} onChange={_handleSearchTextChange} />
                </Col>
              </Row> */}
              <div className="table-responsive mt-3">
                <DataTable
                  striped
                  pagination
                  data={tableData}
                  className="display"
                  paginationServer
                  progressPending={isLoading}
                  paginationTotalRows={totalVerifications}
                  paginationPerPage={itemsPerPage}
                  paginationDefaultPage={page}
                  onChangePage={(newPage) => setPage(newPage)}
                  onChangeRowsPerPage={_handleItemPerPageSelect}
                  columns={[
                    {
                      name: "Name",
                      cell: (row) => {
                        const name = row?.brand?.name || row?.retailer?.name;
                        const tooltipId = `brand-tooltip-${row?.id}`;
                        return (
                          <>
                            <h6
                              id={tooltipId}
                              style={{
                                display: "-webkit-box",
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                              }}
                            >
                              {name}
                            </h6>
                            <UncontrolledTooltip placement="top" target={tooltipId}>
                              {name}
                            </UncontrolledTooltip>
                          </>
                        );
                      },
                    },
                    {
                      name: "Type",
                      cell: (row) => {
                        const type = row?.brand_id ? 'brand' : 'retailer'
                        return (
                          <>
                            <h6
                              style={{
                                display: "-webkit-box",
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                              }}
                            >
                              {type}
                            </h6>
                          </>
                        );
                      },
                    },
                    {
                      name: "Status",
                      cell: (row) => {
                        const status = row?.status || 'failed'
                        return (
                          <>
                            <h6
                              style={{
                                display: "-webkit-box",
                                color: status === 'failed' ? 'red' : status === 'processing' ? 'orange' : 'green',
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                              }}
                            >
                              {getCamelCaseWord(status === 'failed' ? 'required review' : status)}
                            </h6>
                          </>
                        );
                      },
                    },
                    {
                      name: "Updates to verify",
                      cell: (row) => {
                        const keys = Object.keys(row?.details || {}).join(', ')
                        return (
                          <>
                            <h6
                              style={{
                                display: "-webkit-box",
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                              }}
                            >
                              {keys || '--'}
                            </h6>
                          </>
                        );
                      },
                    },
                    {
                      name: "Submitted At",
                      cell: (row) => {
                        return (
                          <>
                            <h6
                              style={{
                                display: "-webkit-box",
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                              }}
                            >
                              {formatDate(row?.created_at)}
                            </h6>
                          </>
                        );
                      },
                    },
                    {
                      name: "Action",
                      cell: (row) => {
                        return (
                          <>
                            <Button
                              color='primary'
                              onClick={() => navigate('/verify-update', { state: { verification: row } })}
                              style={{
                                display: "-webkit-box",
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                              }}
                            >
                              View Details
                            </Button>
                          </>
                        );
                      },
                    },
                  ]}
                />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Container>
    </div>
  )
}

const formatDate = (dateString) => {
  if (!dateString) return '--';
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

const mapStateToProps = (state) => ({
  totalVerifications: state.verifications.totalVerifications,
  selectedFilters: state.verifications.selectedFilters,
  verifications: state.verifications.verifications,
});

const mapDispatchToProps = {
  getVerifications: getVerificationsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Verifications);
